import { Flex, Wrapper } from 'ui';
import { ChatContentLayout } from '../../chat-content-layout';
import { ChatDetailHeaderSkeleton } from '../../chat-detail-header-skeleton';
import { ChatDetailMessagesSkeleton } from '../../chat-detail-messages-skeleton';
import { ChatSidebarSkeleton } from '../../chat-sidebar-skeleton';
import { ChatroomSidebar } from '../../chatroom-sidebar';
import type { ChatroomsSearchParamsOptions } from '../../types';

type P = {
  onCreateChatClicked: () => Promise<void>;
  searchParamsOptions: ChatroomsSearchParamsOptions;
};

const ChatroomsSkeleton = ({ onCreateChatClicked, searchParamsOptions }: P) => (
  <ChatContentLayout
    left={
      <ChatroomSidebar onCreateChatClicked={onCreateChatClicked} searchParamsOptions={searchParamsOptions}>
        <ChatSidebarSkeleton />
      </ChatroomSidebar>
    }
    right={
      <Flex vertical>
        <ChatDetailHeaderSkeleton />
        <Wrapper paddingHorizontal="ms" paddingVertical="ms">
          <ChatDetailMessagesSkeleton />
        </Wrapper>
      </Flex>
    }
  />
);

export default ChatroomsSkeleton;
